import * as React from 'react';
import { OpgaveAfsnit } from '../../models/OpgaveAfsnit';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import DraftHelper from '../../infrastructure/DraftHelper';
import RichTextEditor from '../../uiComponents/input/RichTextEditor';

export interface KonkurrenceOpgaveAfsnitProps {
    afsnit: OpgaveAfsnit;
}

class KonkurrenceOpgaveAfsnit extends React.Component<KonkurrenceOpgaveAfsnitProps, any> {
    getEditorState() {
        return DraftHelper.getContentAsEditorState(this.props.afsnit.indhold);
    }

    render() {
        return (
            <Row className='opgaveafsnit'>
                <Col md={3}>
                    <h2>{this.props.afsnit.overskrift}</h2>
                </Col>
                <Col md={8}>
                    <RichTextEditor readOnly={true} editorState={this.getEditorState()} />
                </Col>
            </Row>
        );
    }
}

export default KonkurrenceOpgaveAfsnit;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceOpgaveAfsnit.tsx